module.exports = __webpack_public_path__ + "img/LKR.409b723c.svg";